export const setFeatureFlagVersion = (version: string) => {
  process.env.FEATURE_FLAGS_VERSION = version;
};
export const getFeatureFlagVersion = () =>
  `v${process.env.FEATURE_FLAGS_VERSION ?? 'NA'}`;
